import React from "react";
import styled from "styled-components";
import { FaInfoCircle } from "react-icons/fa";

const Container = styled.div`
  background-image: url("/Link_expired_background.png");
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #dedede;
`;

const Content = styled.div`
  text-align: center;
  background: white;
  width: 60%;
  height: 70%;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 12px 20px 10px 0px rgb(12 4 4 / 12%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between; /* Ensure footer is at the bottom */
`;

const Image = styled.div`
  background-image: url("/broken_link.png");
  background-size: contain;
  width: 200px;
  height: 200px;
`;

const Title = styled.h1`
  font-size: 2.5em;
  color: #007bff; 
  margin-bottom: 20px;
`;

const Footer = styled.footer`
  background-color: #ffdddd;
  color: #ff0000;
  font-size: 1.2em;
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: 100%; 
  justify-content: center; 
  margin-top: 20px;
`;

const Icon = styled(FaInfoCircle)`
  margin-right: 10px;
  font-size: 1.5em;
`;

const LinkExpiredPage = () => {
  return (
    <Container>
      <Content>
        <Title>Link Expired</Title>
        <Image></Image>

        <Footer>
          <Icon />
          Sorry, the link you are trying to open has expired or is no longer
          valid. Please contact the admin.
        </Footer>
      </Content>
    </Container>
  );
};

export default LinkExpiredPage;
